import { setIsEU } from '@dtx-company/inter-app/src/redux/slices/current-session-slice'
import { useDispatch } from 'react-redux'
import {
  useIsEULoaded,
  useIsEU as useIsEUSelector
} from '@dtx-company/inter-app/src/redux/selectors/currentSessionSelectors'
import React, { useEffect } from 'react'

export function useCheckEU(callback: () => void): void {
  const { isEU } = useIsEU()
  React.useEffect(() => {
    if (isEU) callback()
  }, [callback, isEU])
}

export function useIsEU(): {
  isEU?: boolean
  isEULoaded: boolean
} {
  const isEU = useIsEUSelector()
  const isEULoaded = useIsEULoaded()

  return {
    isEU,
    isEULoaded
  }
}

/**
 * Fetches geolocation from onetrust to check if the user is in the EU.
 * Note: this is a jsonp endpoint.
 */
export const useFetchGeolocation = (continent?: string): void => {
  const dispatch = useDispatch()

  useEffect(() => {
    if (!continent) {
      // this is the likely path when running without the cloudflare worker
      // `flowcode-worker`
      const script = document.createElement('script')

      const cleanup = (): void => {
        if (script?.parentNode) script.parentNode.removeChild(script)
        window.geofeed = (): void => undefined
      }

      window.geofeed = function (options) {
        const isEU = options.continent === 'EU'
        dispatch(setIsEU({ isEU }))
        cleanup()
      }

      script.setAttribute(
        'src',
        'https://geolocation.onetrust.com/cookieconsentpub/v1/geo/location/geofeed'
      )
      document.head.appendChild(script)

      return () => {
        cleanup()
      }
    } else {
      dispatch(setIsEU({ isEU: continent === 'EU' }))
    }
  }, [dispatch, continent])
}
